import * as React from "react";
import { ui } from "../../../../contracts";
import { SecondaryHeading } from "../SecondaryHeading";
import { HeadingTitle } from "../HeadingTitle";
export const PreliveOutrightHeading = (props) => React.createElement(React.Fragment, null,
    React.createElement(SecondaryHeading, { componentPrefix: props.componentPrefix },
        React.createElement(HeadingTitle, { name: props.name, eventsCount: "" }),
        props.mbnTag &&
            React.createElement(ui.MbnIcon, { tagNumber: props.mbnTag })),
    props.children);
//# sourceMappingURL=PreliveOutrightHeading.js.map